import React from 'react'
import PropTypes from 'prop-types'
import { OneColumnBanner as BannerOneColumnComponent } from '@ampdx/component-library/dist/components/'
import { APIENDPOINT, getCWPEnvironmentForURL } from '../../../../utils/common-utils'

const BannerOneColumn = props => {
  const env = getCWPEnvironmentForURL(window.location.href)
  const galleryPath = APIENDPOINT(env).baseGallery
  const svg = `${galleryPath}content/gallery/ampmicrosites/brand-icons`
  let facet
  const hasFacet = props?.content?.bgColor?.includes('facet')
  if (hasFacet) {
    facet = `${galleryPath}content/gallery/ampmicrosites/facets/banner-facet-${
      props?.content?.bgColor?.replace('-facet', '') || 'midnightblue'
    }.svg`
  }
  const bgColor = facet || props.content.bgColor || 'midnight-blue'

  const newContent = {
    ...props.content,
    svgUrl: svg,
    bgColor,
  }

  return <BannerOneColumnComponent content={{ ...newContent }} />
}
BannerOneColumn.propTypes = {
  content: PropTypes.object,
}
export default BannerOneColumn
